module.exports = __webpack_public_path__ + "img/bkl1.7fb8fc0a.jpg";